import { StyledInput } from './styles'
import { InputProps } from './types'

const Input: React.FC<InputProps> = ({ ...props }) => <StyledInput {...props} />

export default Input
